export const THEME_GREY = '--theme-grey';
export const THEME_SECONDARY = '--theme-secondary-color';

const getCssVariable = (type: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(type);

export default getCssVariable;
